import React, { useMemo } from 'react';
import { IconHome, IconUpload } from '@tabler/icons-react';

import Sidebar from './Sidebar';
import { ModuleLink } from './SidebarItem';
import { useAuth } from '../../context/AuthProvider';
import { checkUserRole } from '../../utility/userRoles';
import { PRICE_SURVEY_DATA_UPLOAD_ROLES } from '../../constants/priceSurveyUploadAccess';

function PriceSurveysSidebar() {
    const { authUser } = useAuth();

    const moduleLinks = useMemo((): ModuleLink[] => {
        const links: ModuleLink[] = [
            {
                label: 'Home',
                icon: IconHome,
                path: '',
            },
        ];
        if (checkUserRole(authUser, PRICE_SURVEY_DATA_UPLOAD_ROLES)) {
            links.push({
                label: 'Upload',
                icon: IconUpload,
                path: 'upload',
            });
        }
        return links;
    }, [authUser]);

    return <Sidebar moduleLinks={moduleLinks} pathPrefix="/price-surveys/" />;
}

export default PriceSurveysSidebar;
